import React from 'react';
import ToDoItem from './ToDoItem';

const ToDoItemList = ({todos, onToggle, onRemove}) => {
    // todos = 출력내용
    // onToggle = 체크기능
    // onRemove = 삭제기능
    return (
        <>
            <div>
                {/* <ToDoItem text='안녕하세요'/>
                <ToDoItem text='오늘은 월요일'/>
                <ToDoItem text='리액트 todolist 구현하기'/> */}
                {todos.map(({id, text, checked}) => (
                    <ToDoItem id={id} text={text} checked={checked} onToggle={onToggle} onRemove={onRemove} key={id}/>
                ))}
            </div>
        </>
    );
}

export default ToDoItemList;